export const FileUploadValues = {
  maxFileSize: 250 * 1024 * 1024,
  invalidFileSizeMessageSummary: `{0}:`,
  invalidFileSizeMessageDetail: `Превышен максимально допустимый размер файла {0} .`,
  cancelLabel: `Отмена`,
  chooseLabel: `Добавить`,
  uploadLabel: `Загрузить`,
  emptyMessage: `Перетащите файлы сюда`,
  accept: `.7z, .avif, .bmp, .doc, .docx, .dwg, .dxf, .gz, .jar, .jpeg., .jpg, .lir, .pdf, .png, .rar, .spr, .svg, .tiff, .xls, .xlsx, .xlsm, .zip, .eml, .msg, .nwd, .nwc, .rvt`
}